import { render } from "./HeaderButtons.vue?vue&type=template&id=483099fc&scoped=true"
import script from "./HeaderButtons.vue?vue&type=script&lang=js"
export * from "./HeaderButtons.vue?vue&type=script&lang=js"

import "./HeaderButtons.vue?vue&type=style&index=0&id=483099fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483099fc"]])

export default __exports__